import * as amplitude from '@amplitude/analytics-browser'
import { EventProps, UserProfile, ITrackingProvider, TrackingInitOptions } from '../../../interfaces/event-tracker'

export class AmplitudeWebProvider implements ITrackingProvider {
  private readonly apiKey: string

  constructor (apiKey: string) {
    this.apiKey = apiKey
  }

  init (options?: TrackingInitOptions): void {
    amplitude.init(this.apiKey, {
      autocapture: false,
      defaultTracking: false,
      ...(options?.appVersion != null ? { appVersion: options.appVersion } : {})
    })
  }

  trackEvent ({ key, metadata }: EventProps): void {
    try { amplitude.track(key, metadata) } catch {}
  }

  setUser (user: UserProfile): void {
    try {
      amplitude.setUserId(user.uid)
      const identify = new amplitude.Identify()
      identify.set('auraview_2', true)
      identify.set('Login ID', user.aid)
      identify.set('User ID', user.uid)
      identify.set('Email', user.email)
      identify.set('Name', `${user.nombre} ${user.apellido}`)
      identify.set('Number of Workspaces', Object.keys(user.escritorios).length)
      if (user.escritorio_seleccionado && user.escritorios[user.escritorio_seleccionado]) {
        const ws = user.escritorios[user.escritorio_seleccionado]
        identify.set('Workspace Name', ws.nombre)
        identify.set('Workspace ID', user.escritorio_seleccionado)
        identify.set('Workspace Custom', ws.marca_blanca)
        identify.set('Workspace Invitation Accepted', ws.estado === 1)
      }
      identify.set('Workspace Admin', user.admin)
      identify.set('Workspace Supervisor', user.supervisa)
      identify.set('Signed up', new Date(user.fecha_alta).toISOString())
      identify.set('Ha Total', user.ha.cuota)
      identify.set('Ha Used', Math.round(user.ha.consumidas))
      identify.set('Language', user.locale)
      identify.set('Offline Maps', user.mapas_offline)
      identify.set('Plan', user.tipo_usuario)
      identify.set('Desarrollador', user.dev)
      identify.set('Perfil', user.perfil)
      identify.set('User Type', user.tipo_usuario)
      amplitude.identify(identify)
    } catch {}
  }
}
